var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" something here "),_c('option-manager',{attrs:{"storeId":_vm.storeId,"menuDraftVariation":_vm.menuDraftVariation,"questionId":_vm.questionId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }